import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import ListWrapper from "../utils/ListWrapper" ;
import ScrollView2 from "./ScrollView2" ;
import TextView from "./TextView" ;
import Time from "../classes/Time" ;
import CollectionUtils from "../utils/CollectionUtils" ;

type _TimePickerOnTimeChange = ( time : Time ) => void ;


  export  interface  TimePickerProps extends  BaseUIProps {   key?: string ;
   onTimeChange?: _TimePickerOnTimeChange ;
 }

   class  _TimePickerState extends  ObservableComponent<TimePickerProps> {   column2ScrollController: ui.ScrollController = new ui.ScrollController() ;
   column3ScrollController: ui.ScrollController = new ui.ScrollController() ;
   hours: Array<number> = ListWrapper.widget(this,'hours') ;
   minutes: Array<number> = ListWrapper.widget(this,'minutes') ;
   selectedHour: string = '' ;
   selectedMinutes: string = '' ;
   selectedMeridian: string = '' ;
 public constructor ( props : TimePickerProps ) {
 super(props);

this.initState();
 }
  public initState (  ) {
 super.initState();

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.computeHours();

this.computeMinutes();

this.on([ 'hours', 'minutes', 'selectedHour', 'selectedMeridian', 'selectedMinutes' ],this.rebuild);
 }
  public setHours ( val : Array<number> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.hours,val);

if ( !isValChanged ) {
 return ; 
 }

this.hours.clear();

this.hours.addAll(val);

this.fire('hours',this);
 }
  public addToHours ( val : number,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.hours.contains(val) ) this.hours.add(val);
 }
 else {
 this.hours.remove(this.hours.elementAt(index));

this.hours.add(val);
 }

this.fire('hours',this,val,true);
 }
  public removeFromHours ( val : number ) : void {
 this.hours.remove(val);

this.fire('hours',this,val,false);
 }
  public computeHours  =  (  ) : void  =>  {
 try {
 this.setHours(Array.from([ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ]));
 }
 catch ( exception ) {
 console.log(' exception in computeHours : ' + exception.toString());

this.setHours([  ]);
 }
 }
  public setMinutes ( val : Array<number> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.minutes,val);

if ( !isValChanged ) {
 return ; 
 }

this.minutes.clear();

this.minutes.addAll(val);

this.fire('minutes',this);
 }
  public addToMinutes ( val : number,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.minutes.contains(val) ) this.minutes.add(val);
 }
 else {
 this.minutes.remove(this.minutes.elementAt(index));

this.minutes.add(val);
 }

this.fire('minutes',this,val,true);
 }
  public removeFromMinutes ( val : number ) : void {
 this.minutes.remove(val);

this.fire('minutes',this,val,false);
 }
  public computeMinutes  =  (  ) : void  =>  {
 try {
 this.setMinutes(Array.from([ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59 ]));
 }
 catch ( exception ) {
 console.log(' exception in computeMinutes : ' + exception.toString());

this.setMinutes([  ]);
 }
 }
  public setSelectedHour ( val : string ) : void {
 let isValChanged :boolean=this.selectedHour !== val;

if ( !isValChanged ) {
 return ; 
 }

this.selectedHour=val;

this.fire('selectedHour',this);
 }
  public setSelectedMinutes ( val : string ) : void {
 let isValChanged :boolean=this.selectedMinutes !== val;

if ( !isValChanged ) {
 return ; 
 }

this.selectedMinutes=val;

this.fire('selectedMinutes',this);
 }
  public setSelectedMeridian ( val : string ) : void {
 let isValChanged :boolean=this.selectedMeridian !== val;

if ( !isValChanged ) {
 return ; 
 }

this.selectedMeridian=val;

this.fire('selectedMeridian',this);
 }
  public render (  ) : ReactNode {
 return ui.Column({ mainAxisSize:ui.MainAxisSize.min, children:[ TextView({ data:'Select Time', style:new ui.TextStyle({fontWeight:ui.FontWeight.w700,fontFamily:'Poppins',fontSize:18}), className:'xe478 hc', key:'0' }), ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.center, children:[ ui.Container({ child:ScrollView2({child:ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ (this.hours).expand(( forItem1 ) => [ TextView({ data:forItem1.toString(), textAlign:ui.TextAlign.center, style:new ui.TextStyle({color:this.selectedHour !== '' && this.selectedHour === forItem1.toString() ? ui.HexColor.fromHexInt(0xff766dfe) : ui.HexColor.fromHexInt(0xff000000),fontSize:15,fontWeight:ui.FontWeight.w600}), className:'xc70a hc', key:forItem1?.toString(), onTap:( e ) => {
 e.stopPropagation();

this.onHourSelectedHandler(forItem1);
 }
 }) ]) ] }),scrollDirection:ui.Axis.vertical,className:'x4f3 hc vc v',controller:this.column2ScrollController}), className:'xa54 hc vc', key:'0' }), ui.Container({ child:ScrollView2({child:ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ (this.minutes).expand(( forItem2 ) => [ TextView({ data:forItem2.toString(), textAlign:ui.TextAlign.center, style:new ui.TextStyle({color:this.selectedMinutes !== '' && this.selectedMinutes === forItem2.toString() ? ui.HexColor.fromHexInt(0xff766dfe) : ui.HexColor.fromHexInt(0xff000000),fontSize:15,fontWeight:ui.FontWeight.w600}), className:'x1e47 hc', key:forItem2?.toString(), onTap:( e ) => {
 e.stopPropagation();

this.onMinutesSelectedHandler(forItem2);
 }
 }) ]) ] }),scrollDirection:ui.Axis.vertical,className:'x8c4 hc vc v',controller:this.column3ScrollController}), className:'xa49d hc vc', key:'1' }), ui.Container({ child:ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, mainAxisAlignment:ui.MainAxisAlignment.center, children:[ TextView({ data:'AM', style:new ui.TextStyle({fontSize:15,color:this.selectedMeridian !== '' && this.selectedMeridian === 'AM' ? ui.HexColor.fromHexInt(0xff766dfe) : ui.HexColor.fromHexInt(0xff000000),fontWeight:ui.FontWeight.w600}), className:'x350 hc', key:'0', onTap:( e ) => {
 e.stopPropagation();

this.onMeridianChangeHandler();
 }
 }), TextView({ data:'PM', style:new ui.TextStyle({color:this.selectedMeridian !== '' && this.selectedMeridian === 'PM' ? ui.HexColor.fromHexInt(0xff766dfe) : ui.HexColor.fromHexInt(0xff000000),fontSize:15,fontWeight:ui.FontWeight.w600}), className:'x572 hc', key:'1', onTap:( e ) => {
 e.stopPropagation();

this.onMeridianChangeHandler1();
 }
 }) ], className:'x9043 hc vc v' }), className:'x9eb hc vc', key:'2' }) ], className:'xe34 hc h', key:'1' }) ], className:ui.join('TimePicker hc vc ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }) ; 
 }
  public onHourSelectedHandler  =  ( forItem1 : number ) : void  =>  {
 this.setSelectedHour(forItem1.toString());

this.onTimeReturnHandler(this.selectedHour,this.selectedMinutes,this.selectedMeridian);
 }
  public onMinutesSelectedHandler  =  ( forItem2 : number ) : void  =>  {
 this.setSelectedMinutes(forItem2.toString());

this.onTimeReturnHandler(this.selectedHour,this.selectedMinutes,this.selectedMeridian);
 }
  public onMeridianChangeHandler  =  (  ) : void  =>  {
 this.setSelectedMeridian('AM');

this.onTimeReturnHandler(this.selectedHour,this.selectedMinutes,this.selectedMeridian);
 }
  public onMeridianChangeHandler1  =  (  ) : void  =>  {
 this.setSelectedMeridian('PM');

this.onTimeReturnHandler(this.selectedHour,this.selectedMinutes,this.selectedMeridian);
 }
  public onTimeReturnHandler  =  ( hour : string,minutes : string,meridian : string ) : void  =>  {
 if ( hour !== '' && minutes !== '' && meridian !== '' ) {
 let hour1 :number=Number.parseInt(hour);

let minutes1 :number=Number.parseInt(minutes);

if ( meridian === 'AM' ) {
 if ( hour1 % 12 === 0 ) {
 hour1=0;
 }
 }
 else {
 if ( hour1 % 12 !== 0 ) {
 hour1=12 + hour1;
 }
 }

this.onTimeChange(Time.of(hour1,minutes1,0,0));
 }
 }
  public get onTimeChange (  ) : _TimePickerOnTimeChange {
 return this.props.onTimeChange ; 
 }
 }
export default function TimePicker ( props : TimePickerProps ) {
 return React.createElement(_TimePickerState,props) ; 
 }
